var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnchedked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.0372 0 0 4.0372 0 9C0 13.9628 4.0372 18 9 18C13.9628 18 18 13.9628 18 9C18 4.0372 13.9628 0 9 0Z",
    fill: "#FDE7E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06072 14.1419C9.62118 14.1419 10.0755 13.6906 10.0755 13.1339C10.0755 12.5773 9.62118 12.126 9.06072 12.126C8.50025 12.126 8.0459 12.5773 8.0459 13.1339C8.0459 13.6906 8.50025 14.1419 9.06072 14.1419Z",
    fill: "#F6724F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06456 10.3704C9.66304 10.3704 10.1574 9.87935 10.1574 9.28491V4.94292C10.1574 4.34848 9.66304 3.85742 9.06456 3.85742C8.46608 3.85742 7.97168 4.34848 7.97168 4.94292V9.25906C7.97168 9.87935 8.46608 10.3704 9.06456 10.3704Z",
    fill: "#F6724F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnchedked);
export default __webpack_public_path__ + "static/media/unchedked.0ce60b4c448fa5577ddb008f8ad414b9.svg";
export { ForwardRef as ReactComponent };